export const PANEL_SHELL_CLASSNAME = 'shadow-s rounded-8 overflow-clip relative max-w-[780px] w-full mx-auto';

export const CARD_SHELL_CLASSNAME =
    'meglerpromo-card relative w-[150px] min-w-[150px] h-[246px] rounded-16 overflow-clip no-underline hover:shadow-s transition-shadow hover:no-underline focus:no-underline active:no-underline';
